import React, { useState } from "react";
import { cn } from "../../utils/cn";
import { ChevronDown } from "lucide-react";

export const AccordionTab = ({ header, children, isOpen, onToggle, className }) => {
  return (
    <div className={cn("border border-urb-border rounded-xl overflow-hidden bg-urb-card/70 transition-all", className)}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full px-4 py-3.5 flex items-center justify-between text-left font-bold text-sm text-white hover:text-urb-primary transition-colors bg-transparent border-none cursor-pointer"
      >
        <span>{header}</span>
        <ChevronDown
          className={cn(
            "w-4 h-4 text-slate-400 transition-transform duration-200 shrink-0 ml-2",
            isOpen && "rotate-180 text-urb-primary"
          )}
        />
      </button>
      {isOpen && (
        <div className="px-4 pb-4 pt-1 text-slate-300 text-xs sm:text-sm leading-relaxed border-t border-urb-border/50">
          {children}
        </div>
      )}
    </div>
  );
};

export const Accordion = ({ children, multiple = false, activeIndex, className }) => {
  const [openIndexes, setOpenIndexes] = useState(
    activeIndex !== undefined
      ? Array.isArray(activeIndex)
        ? activeIndex
        : [activeIndex]
      : []
  );

  const handleToggle = (index) => {
    if (multiple) {
      setOpenIndexes((prev) =>
        prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
      );
    } else {
      setOpenIndexes((prev) => (prev.includes(index) ? [] : [index]));
    }
  };

  return (
    <div className={cn("flex flex-col gap-2.5 w-full", className)}>
      {React.Children.map(children, (child, idx) => {
        if (!React.isValidElement(child)) return null;
        return React.cloneElement(child, {
          isOpen: openIndexes.includes(idx),
          onToggle: () => handleToggle(idx),
        });
      })}
    </div>
  );
};

export default Accordion;
